export const INIT_ROUTE_DATA_REQUEST = 'INIT_ROUTE_DATA_REQUEST';
export const INIT_ROUTE_LOADING = 'INIT_ROUTE_LOADING';
export const SET_ROUTE_DATA_SUCCESS = 'SET_ROUTE_DATA_SUCESS';
export const SET_ROUTE_DATA_ERROR = 'SET_ROUTE_DATA_ERROR';

export const INIT_START_DATE_CHANGE = 'INIT_START_DATE_CHANGE';
export const INIT_END_DATE_CHANGE = 'INIT_END_DATE_CHANGE';
export const SET_START_DATE_CHANGE = 'SET_START_DATE_CHANGE';
export const SET_END_DATE_CHANGE = 'SET_END_DATE_CHANGE';

export const INIT_DATE_RESET = 'INIT_DATE_RESET';
